import * as BannerDefaults from '../banner-defaults';
function getField(type, location) {
    let field = {};
    switch (type) {
        case BannerDefaults.MODAL:
            field = {
                action_location: location || 'in-bottom',
                placement_type: BannerDefaults.MODAL
            };
            break;
        case BannerDefaults.BUTTON:
            field = {
                action_location: 'header',
                placement_type: BannerDefaults.CTA
            };
            break;
        default:
            field = {
                action_location: 'above-header',
                placement_type: BannerDefaults.BANNER
            };
    }
    return field;
}
function handleDownloadEdapEvent(trackingContext, type) {
    const field = getField(type);
    trackingContext.trigger('native_adoption_placement.selected', field);
    trackingContext.trigger('native_adoption_placement.submitted', field);
}
function handleDismissEdapEvent(trackingContext, type, location) {
    const field = getField(type, location);
    trackingContext.trigger('native_adoption_placement.dismissed', field);
}
function handleOnloadEdapEvent(trackingContext, type) {
    const field = getField(type);
    trackingContext.trigger('native_adoption_placement.presented', field);
}
function handleHiddenEdapEvent(trackingContext, type) {
    const field = getField(type);
    trackingContext.trigger('native_adoption_placement.hidden', field);
}
export {
    handleDownloadEdapEvent,
    handleDismissEdapEvent,
    handleOnloadEdapEvent,
    handleHiddenEdapEvent
};
